module.exports = __webpack_public_path__ + "media/Card-flip-sound-effect.c5738ed6.mp3";